module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = path
// module chunks = 5